module.exports = __webpack_public_path__ + "static/media/other-skills.6f990fc6.svg";